import React from 'react';
import { CheckCircle } from 'lucide-react';
import { usePurchaseNotifications } from '../hooks/usePurchaseNotifications';
export function PurchasePopup() {
  const notification = usePurchaseNotifications();
  if (!notification || !notification.visible) return null;
  return <div className="fixed bottom-4 right-4 z-40 max-w-sm w-full animate-slide-up" data-id="element-8">
      <div className="bg-white rounded-lg shadow-xl p-4 border-l-4 border-green-500 flex items-start gap-3" data-id="element-9">
        <div className="flex-shrink-0" data-id="element-10">
          <div className="bg-green-100 rounded-full p-2" data-id="element-11">
            <CheckCircle className="w-6 h-6 text-green-600" data-id="element-12" />
          </div>
        </div>
        <div data-id="element-13">
          <p className="font-bold text-gray-900 text-sm" data-id="element-14">{notification.name}</p>
          <p className="text-gray-600 text-xs" data-id="element-15">de {notification.location}</p>
          <p className="text-green-700 text-xs font-medium mt-1" data-id="element-16">
            acaba de comprar Matemática Lista™
          </p>
        </div>
      </div>
    </div>;
}